module.exports = __webpack_public_path__ + "img/logo_agco.92367e4c.svg";